export default function getFileExtension(fileName) {
    const regexp = /(?:\.([^.]+))?$/;

    return regexp.exec(fileName)[1];
}
